import ListComponent from "./ListComponent";
import ArticlesList from "../Design/ArticlesList";
import Navigation from "../Design/Navigation";
import WindowLocation from "../Services/WindowLocation";
import DropDown from "../Design/DropDown";
import React from "react";

export default class Posts extends ListComponent {
    constructor(props) {
        super(props);

        this.handleSearch = this.handleSearch.bind(this);
        this.handleCategory = this.handleCategory.bind(this);
        this.handleDropDown = this.handleDropDown.bind(this);
        this.resetSearch = this.resetSearch.bind(this);

        this.querySearchTimeOut = null;
    }

    componentDidMount() {
        WindowLocation.getWindowLocation();

        // if(this.config.params && this.config.params.categories && this.config.params.categories.default) {
        //     let category = this.config.params.categories.render.values.find(category => category.slug === this.config.params.categories.default);
        //     this.source = category.value;
        // }

        if (window.location.hashObj && window.location.getHashObj(this.config.params.categories.key)) {
            let c = window.location.getHashObj(this.config.params.categories.key);
            let category = this.config.params.categories.render.values.find(category => category.slug === c);

            this.source = category.value;
        }

        super.componentDidMount();
    }

    resetSearch() {
        if(this.searchInput) {
            this.searchInput.value = '';
        }
    }

    handleCategory({value, slug}) {
        super.resetParams(() => {
            const {params: {categories: {key}}} = this.config;

            this.source = value;

            window.location.removeHash('page');
            window.location.removeHash('s');
            window.location.addHash(key, slug);

            this.resetSearch();

            WindowLocation.rewriteUrl();

            this.updateParams(key, slug);
        });
    }

    handleSearch({currentTarget: {value: search}}) {
        if (this.querySearchTimeOut) {
            clearTimeout(this.querySearchTimeOut);
        }

        this.querySearchTimeOut = setTimeout(() => {
            if (search) {
                window.location.addHash('s', search);
            } else {
                window.location.removeHash('s');
                this.resetSearch();
            }

            WindowLocation.rewriteUrl();

            this.updateParams('s', search);
        }, 300);
    }

    resetParams(callback = () => {
    }) {
        super.resetParams(() => {
            let category = this.config.params.categories.render.values.find(category => (this.source === category.value));
            window.location.addHash(this.config.params.categories.key, category.slug);
            callback();
        });
    }

    handleDropDown(key, value) {
        this.resetParams(() => {
            if (value) {
                window.location.addHash(key, value);
            } else {
                window.location.removeHash(key);
            }

            WindowLocation.rewriteUrl();

            this.updateParams(key, value ? value : null);
        });
    }

    render() {
        const {page, state: {list, loaded, totalPages, params: activeParams}, config: {params}, source} = this;

        return <>
            {params && params.categories && params.categories.render &&
            <Navigation links={params.categories.render.values} onClick={this.handleCategory}
                        active={source}/>}

            <div className="filter-bar styled-select">
                <div>
                    Filter By:
                    {params && Object.entries(params).map(([key, param]) => (param.render && param.render !== false && param.app && param.app === 'DropDown') ?
                        <DropDown name={param.key}
                                  options={param.render.values}
                                  defaultValue={activeParams[param.key]}
                                  onChange={(val) => this.handleDropDown(param.key, val)}/> : null)}
                </div>
                <div className={'search'}>
                    <input type="text" placeholder="Search for name/keyword" onChange={this.handleSearch} ref={ref => this.searchInput = ref}
                           defaultValue={(window.location.hashObj && window.location.getHashObj('s')) ? window.location.getHashObj('s') : ''}/>
                </div>
            </div>

            <ArticlesList articles={list} key={'fp-post'}/>
            {(loaded && list && list.length === 0) && <p>No results found.</p>}

            {(loaded && page < totalPages) && <div className={"load-more-container"}>
                <p className="align-center">
                    <a href={'#'} className="btn" onClick={this.loadMore}>
                        <span>
                            Load more
                        </span>
                    </a>
                </p>
            </div>}

            {!loaded && <div className={"load-more-container"}>
                <div className={"fp-loading"}><span/><br/> Loading</div>
            </div>}
        </>;
    }
}